module.exports = __webpack_public_path__ + "img/clue07_bg.680abc63.png";